module.exports = "/**\n* Import the colors and spacers from cf-design\n*/\n::ng-deep #error-icon-color path.st0 {\n  fill: #f78b54;\n  stroke: none; }\n.error-icon-size {\n  font-size: 25px; }\n@media only screen and (min-width: 768px) and (max-width: 991px), only screen and (max-width: 767px) {\n  .error-icon-position {\n    position: relative;\n    top: -20px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/new-registration/modals/confirm-info-reenter-modal/confirm-info-reenter-modal.component.scss
// module id = ./src/app/new-registration/modals/confirm-info-reenter-modal/confirm-info-reenter-modal.component.scss
// module chunks = main